import { OnboardingStep } from '../../OnboardingStep/OnboardingStep'
import { getStepStatus } from '../utils'

interface CalendarStepProps {
  readonly completed: boolean
  readonly enabled: boolean
}

export function CalendarStep({
  completed,
  enabled
}: Readonly<CalendarStepProps>) {
  const handleCalendarSync = () => {
    // Pending logic implementation
  }

  const status = getStepStatus(completed, enabled)

  return (
    <OnboardingStep
      title="Connect Your Calendar"
      description="Stay informed about your upcoming deliveries, order deadlines, and important subscription dates."
      status={status}
      icon="calendar"
      action={{
        label: 'Connect Calendar',
        onClick: handleCalendarSync
      }}
    />
  )
}
